import styled from "styled-components";
import { BTTO_PROFILE_COLORS, bettoFocusRing } from "../../shared/elements";

export const ToggleTrack = styled.button`
	position: relative;
	flex-shrink: 0;
	width: 44px;
	height: 24px;
	padding: 0;
	border: none;
	border-radius: 12px;
	background: ${({ $active }) => ($active ? BTTO_PROFILE_COLORS.primary : "#3a4150")};
	cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
	opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
	transition: background 0.2s ease;
	${bettoFocusRing}
`;

export const ToggleThumb = styled.span`
	position: absolute;
	top: 3px;
	left: ${({ $active }) => ($active ? "23px" : "3px")};
	width: 18px;
	height: 18px;
	border-radius: 50%;
	background: #fff;
	transition: left 0.2s ease;
`;
